import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TweetEmbed from 'react-tweet-embed';
import { Grid, Segment, Icon, Divider } from 'semantic-ui-react';

const twitterEmbedOptions = { conversation: 'none', cards: 'hidden' };

const ProfileLatestTweets = ({ tweets = [] }) => {
  const chunks = _.chunk(tweets, 3);
  return (
    <Segment padded color="blue">
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <h3>
              <Icon name="twitter" color="blue" /> Latest tweets
            </h3>
            <Divider />
          </Grid.Column>
        </Grid.Row>
        { _.map(chunks, (chunk => <Grid.Row divided columns={3}>
          { _.map(chunk, (tweet => <Grid.Column key={tweet.id}>
            <TweetEmbed
              options={twitterEmbedOptions}
              id={tweet.id}
            />
          </Grid.Column>)) }
        </Grid.Row>))
        }

      </Grid>
    </Segment>
  );
};

ProfileLatestTweets.propTypes = {
  tweets: PropTypes.array.isRequired,
};

export default ProfileLatestTweets;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-latest/profile-latest-tweets.js
 **/